import { gsap } from '../rk-gsap-core'

const initializeNeighbourhoodMapAnimation = () => {
  const burkeMountainHighlight = document.querySelector('.neighbourhood-map-anim-svg .burke-mountain-highlight')
  const rocklinHighlight = document.querySelector('.neighbourhood-map-anim-svg .rocklin-highlight')

  // oscillate from 0 to 0.5 opacity
  if (burkeMountainHighlight) {
    gsap.to(burkeMountainHighlight, {
      opacity: 0.5,
      duration: 1,
      ease: 'power1.inOut',
      repeat: -1,
      yoyo: true
    })
  }

  if (rocklinHighlight) {
    gsap.to(rocklinHighlight, {
      opacity: 0.5,
      duration: 1,
      ease: 'power1.inOut',
      repeat: -1,
      yoyo: true
    })
  }

  const labelSheenRect = document.getElementById('label-sheen-rect')

  // sweep a warm glare highlight left-to-right across the burke mountain label
  if (labelSheenRect) {
    gsap.fromTo(
      labelSheenRect,
      { attr: { x: 580 } },
      {
        attr: { x: 870 },
        duration: 1.5,
        ease: 'power1.inOut',
        repeat: -1,
        repeatDelay: 3.5
      }
    )
  }

  const logoSheenRect = document.getElementById('logo-sheen-rect')

  // apply the same subtle glare sweep across the Rocklin logo text
  if (logoSheenRect) {
    // Keep the glare hidden while waiting, then reveal only during the sweep.
    gsap.set(logoSheenRect, { attr: { x: 520 }, opacity: 0 })

    gsap
      .timeline({ repeat: -1, delay: 2.5, repeatDelay: 3.5 })
      .set(logoSheenRect, { attr: { x: 520 }, opacity: 1 })
      .to(logoSheenRect, {
        attr: { x: 720 },
        duration: 1.5,
        ease: 'power1.inOut'
      })
      .set(logoSheenRect, { opacity: 0 })
  }

  const rocklinDot = document.querySelector('.neighbourhood-map-anim-svg .rocklin .dot')

  // Subtle breathing pulse for the Rocklin map marker.
  if (rocklinDot) {
    const baseRadius = Number.parseFloat(rocklinDot.getAttribute('r') || '3.4')

    gsap.to(rocklinDot, {
      attr: { r: baseRadius * 1.22 },
      duration: 1.2,
      ease: 'sine.inOut',
      repeat: -1,
      yoyo: true
    })
  }
}

// Neighbourhood Page Animations
export default function initializeNeighbourhoodAnimations() {
  initializeNeighbourhoodMapAnimation()
}